import React, { useMemo } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import { ModalManager } from '@bcraft-frontend-lib/core'
import { PaymentsProvider } from '@bcraft-frontend-lib/payments'
import { SlotsProvider } from '@bcraft-frontend-lib/slots'

import { projectDomainName } from 'shared/constants'
import { getCurrencySymbol } from 'shared/constants/currencies/getCurrencySymbol'
import { useLiveChatVisibility } from 'shared/hooks/useLiveChatVisibility'

import { replaceIcons } from 'modules/PaymentsPage/__data'
import { newProvidersList } from 'modules/SlotsRoot/data/providers'

import { selectIsUserAuthenticated, selectUserCurrency, selectUserData } from 'features/auth/selectors'
import { selectLanguage } from 'features/userSettings/selectors'

import Modal from 'components/Modal/Modal'

import { addNotify } from 'components/Notify'
import { Spinner } from 'components/Spinner'

export const AppProvider: React.FC = ({ children }) => {
	const isAuth = useSelector(selectIsUserAuthenticated, shallowEqual)
	const user = useSelector(selectUserData, shallowEqual)
	const currency = useSelector(selectUserCurrency, shallowEqual)
	const lang = useSelector(selectLanguage, shallowEqual)

	const currencySymbol = useMemo(() => getCurrencySymbol(currency), [currency])

	useLiveChatVisibility()

	return (
		<SlotsProvider
			isAuth={isAuth}
			lang={lang}
			currencySymbol={currencySymbol}
			user={user}
			addNotify={addNotify}
			Loader={<Spinner isLoading />}
			newProvidersList={newProvidersList}
			proxy={projectDomainName}>
			<PaymentsProvider lang={lang} isAuth={isAuth} replaceIcons={replaceIcons}>
				<React.Suspense fallback={<div>Loading...</div>}>
					<ModalManager
						renderModal={({ isOpen, onClose, path, renderComponent, customProps }) => (
							<Modal key={path} open={isOpen} handleClose={onClose} {...customProps}>
								{renderComponent({ path })}
							</Modal>
						)}
					/>
				</React.Suspense>
				{children}
			</PaymentsProvider>
		</SlotsProvider>
	)
}